import { Box, Typography } from "@mui/material";
import { theme } from "src/theme/mui-theme";
import { UploadLayoutIcon } from "src/pages/ProjectDetailsWizard/icons/UploadLayoutIcon";
import React from "react";
import { ts } from "src/utils/translate";
import sampleLayoutImage from "src/pages/ProjectDetailsWizard/images/sample_layout.jpg";
import { FloorFormData, FloorLayout } from "src/pages/PlannerPage/FloorWizard/useUpsertFloor";

interface LayoutStepProps {
    formData: FloorFormData;
    setFormData: (data: FloorFormData) => void;
}

export const FloorWizardChooseLayoutStep = ({ formData, setFormData }: LayoutStepProps) => {

    const layouts = [
        { id: FloorLayout.UPLOAD, label: ts('upload_layout', 'Upload layout'), svg: <UploadLayoutIcon /> },
        { id: FloorLayout.SAMPLE, label: ts('use_sample_layout', 'Use sample layout') },
    ];

    return (
        <Box display="flex" justifyContent="space-between" gap={3} marginBottom={4} marginTop={2}>
            {layouts.map(({ id, label, svg }) => {
                const isSelected = formData.selectedLayout === id;
                return (
                    <Box
                        key={id}
                        onClick={() => {
                            setFormData({ ...formData, selectedLayout: id });
                        }}
                    >
                        <Box
                            sx={{
                                cursor: "pointer",
                                width: 150,
                                height: 150,
                                borderRadius: 2,
                                border: `2px solid ${isSelected ? theme.palette.primary.main : theme.palette.grey[300]}`,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                userSelect: "none",
                            }}
                        >
                            {svg ? (
                                <Box
                                    sx={{
                                        width: 70,
                                        height: 70,
                                        "& svg": {
                                            width: "100%",
                                            height: "100%",
                                            display: "block",
                                        },
                                    }}
                                >
                                    {svg}
                                </Box>
                            ) : (
                                <Box
                                    sx={{
                                        width: "100%",
                                        height: "100%",
                                        borderRadius: 1,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}
                                >
                                    <img
                                        src={sampleLayoutImage}
                                        alt="Sample Layout"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "contain",
                                            filter: "saturate(5%)",
                                        }}
                                    />
                                </Box>
                            )}
                        </Box>

                        <Typography
                            color={isSelected ? theme.palette.primary.main : theme.palette.text.primary}
                            variant="subtitle2"
                            textAlign="center"
                            sx={{ marginTop: 2 }}
                        >
                            {label}
                        </Typography>
                    </Box>
                );
            })}
        </Box>
    );
};